"use client";
import React, { useEffect, useState } from "react";
import { iWidgetChatConfig } from "@/app/models/interfaceChatWidget";

export default function ChatWidgetSimulado({
  config,
  activeTab, // "boton" | "tooltip" | "iframe"
}: {
  config: iWidgetChatConfig;
  activeTab: "boton" | "tooltip" | "iframe";
}) {
  const [isChatOpen, setIsChatOpen] = useState(false);
  
  const [shouldShowIframe, setShouldShowIframe] = useState(activeTab === "iframe");

  const btn = config.button;
  const ifr = config.iframe;

  // ======= Estilos globales =======
  useEffect(() => {
    const prevStyle = document.getElementById("chat-widget-style");
    if (prevStyle) prevStyle.remove();

    const style = document.createElement("style");
    style.id = "chat-widget-style";

    style.textContent = `
      .chat-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 8px 12px;
        background-color: ${btn.backgroundColor};
        color: ${btn.color};
        border-radius: ${btn.borderRadius};
        font-weight: ${btn.fontWeight};
        font-size: ${btn.fontSize};
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        transition: all 0.3s ease;
        ${btn.text
          ? `min-width: ${btn.width}; min-height: ${btn.height};`
          : `width: ${btn.width}; height: ${btn.height};`}
        overflow: visible;
        white-space: nowrap;
        position: relative;
        cursor: pointer;
      }

      .chat-icon {
        flex-shrink: 0;
        color: ${btn.iconColor};
        width: ${btn.iconSize};
        height: ${btn.iconSize};
        transition: transform 0.3s ease;
      }

      .chat-icon svg {
        width: 100%;
        height: 100%;
        stroke: currentColor;
        display: block;
      }

      .chat-button:hover .chat-icon {
        transform: scale(1.15);
      }

      .chat-tooltip {
        position: absolute;
        opacity: 0;
        background-color: ${btn.tooltip.backgroundColor};
        color: ${btn.tooltip.color};
        padding: 6px 10px;
        border-radius: ${btn.tooltip.borderRadius};
        font-size: ${btn.tooltip.fontSize};
        width: ${btn.tooltip.width || "auto"};
        height: ${btn.tooltip.height || "auto"};
        max-width: min(260px, calc(100vw - 20px));
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;
        text-align: center;
        line-height: 1.3;
        z-index: 99999;
        transition: opacity 0.25s ease, transform 0.25s ease;
      }

      ${activeTab === "tooltip"
        ? `
          .chat-tooltip {
            visibility: visible;
            opacity: 1;
          }
        `
        : `
          .chat-tooltip {
            visibility: hidden;
          }
          .chat-button:hover .chat-tooltip {
            visibility: visible;
            opacity: 1;
          }
        `}
  
        
    `;
    document.head.appendChild(style);

    return () => style.remove();
  }, [btn]);

  // ======= Posición del tooltip =======
  useEffect(() => { 
    setShouldShowIframe(activeTab === "iframe");

    // Limpia cualquier estilo anterior
    const oldDynamicStyle = document.getElementById("chat-tooltip-dynamic-style");
    if (oldDynamicStyle) oldDynamicStyle.remove();

    // Crea un nuevo <style> dinámico
    const style = document.createElement("style");
    style.id = "chat-tooltip-dynamic-style";

    // 💡 Inyecta CSS diferente según el tab activo
    style.textContent = `
      .chat-tooltip {
        transition: opacity 0.25s ease, visibility 0.25s ease;
        opacity: ${activeTab === "tooltip" ? "1" : "0"};
        visibility: ${activeTab === "tooltip" ? "visible" : "hidden"};
      }

      ${activeTab === "boton" ? `
        .chat-button:hover .chat-tooltip {
          visibility: visible;
          opacity: 1;
        }
      ` : ""}
    `;
    document.head.appendChild(style);
  
    const tooltip = document.querySelector(".chat-tooltip") as HTMLElement;
    if (!tooltip) return;

    tooltip.style.top = "";
    tooltip.style.bottom = "";
    tooltip.style.left = "";
    tooltip.style.right = "";
    tooltip.style.transform = "";
    tooltip.style.visibility = "";

    const position = btn.tooltip.position || "arriba";
  
    switch (position) {
      case "abajo":
        tooltip.style.top = "calc(100% + 8px)";
        tooltip.style.left = "50%";
        tooltip.style.transform = "translateX(-50%)";
        break;
      case "izquierdo":
        tooltip.style.right = "calc(100% + 8px)";
        tooltip.style.top = "50%";
        tooltip.style.transform = "translateY(-50%)";
        break;
      case "derecho":
        tooltip.style.left = "calc(100% + 8px)";
        tooltip.style.top = "50%";
        tooltip.style.transform = "translateY(-50%)";
        break;
      default:
        tooltip.style.bottom = "calc(100% + 8px)";
        tooltip.style.left = "50%";
        tooltip.style.transform = "translateX(-50%)";
        break;
    }

  }, [btn.tooltip.position, btn.tooltip.text,activeTab]);

  // ======= Render =======

 

  return (
    <>
      
        <button
          hidden={isChatOpen || shouldShowIframe }
          style={{
            position: "fixed",
            bottom: btn.position.bottom,
            right: btn.position.right,
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 0,
            outline: "none",
            zIndex: 9999,
          }}
          onClick={() => setIsChatOpen(true)}
        >
          <span className="chat-button">
            <span
              className="chat-icon"
              dangerouslySetInnerHTML={{ __html: btn.iconSvg }}
            />
            {btn.text && <span className="chat-text">{btn.text}</span>}             
            <span className="chat-tooltip">{btn.tooltip.text}</span>            
          </span>
        </button>
       

      {(isChatOpen || shouldShowIframe) && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            width: ifr.width,
            height: ifr.height,
            background: ifr.backgroundColor,
            border: `1px solid ${ifr.borderColor}`,
            borderRadius: ifr.borderRadius,
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            overflow: "hidden",
            zIndex: 9998,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <button
            onClick={() => setIsChatOpen(false)}
            style={{
              position: "absolute",
              top: "-15px",
              right: "20px",
              transform: "translateX(-50%)",
              width: "50px",
              height: "38px",
              border: "none",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              zIndex: 10000,
              backgroundColor: "#ecf2ff",
              color: "#0048cf",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              paddingBottom: "5px",
              transition: "background-color 0.3s ease",
            }}
            onMouseEnter={(e) =>
              ((e.target as HTMLElement).style.backgroundColor = "#0048cf7e")
            }
            onMouseLeave={(e) =>
              ((e.target as HTMLElement).style.backgroundColor = "#ecf2ff")
            }
          >
            ✕
          </button>

          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#555",
              fontSize: 14,
              background: "#fff",
            }}
          >
            <div>
              <strong>Vista previa del chat</strong>
              <p style={{ fontSize: 12, color: "#888" }}>
                Aquí aparecería el chat real.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}


/*"use client";
import React, { useEffect, useState } from "react";
import { iWidgetChatConfig } from "@/app/models/interfaceChatWidget";

export default function ChatWidgetSimulado({
  config,
  activeTab
}: {
  config: iWidgetChatConfig;
  activeTab:string;
}) {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const btn = config.button;
  const ifr = config.iframe;
  
  // ======= Estilos globales =======
  useEffect(() => {
    const prevStyle = document.getElementById("chat-widget-style");
    if (prevStyle) prevStyle.remove();

    const style = document.createElement("style");
    style.id = "chat-widget-style";

    style.textContent = `
      .chat-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 8px 12px;
        background-color: ${btn.backgroundColor};
        color: ${btn.color};
        border-radius: ${btn.borderRadius};
        font-weight: ${btn.fontWeight};
        font-size: ${btn.fontSize};
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        transition: all 0.3s ease;
        ${btn.text
          ? `min-width: ${btn.width}; min-height: ${btn.height};`
          : `width: ${btn.width}; height: ${btn.height};`}
        overflow: visible;
        white-space: nowrap;
        position: relative;
        cursor: pointer;
      }

      .chat-icon {
        flex-shrink: 0;
        color: ${btn.iconColor};
        width: ${btn.iconSize};
        height: ${btn.iconSize};
        transition: transform 0.3s ease;
      }

      .chat-icon svg {
        width: 100%;
        height: 100%;
        stroke: currentColor;
        display: block;
      }

      .chat-button:hover .chat-icon {
        transform: scale(1.15);
      }

      .chat-tooltip {
        position: absolute;
        visibility: hidden;
        opacity: 0;
        background-color: ${btn.tooltip.backgroundColor};
        color: ${btn.tooltip.color};
        padding: 6px 10px;
        border-radius: ${btn.tooltip.borderRadius};
        font-size: ${btn.tooltip.fontSize};
        width: ${btn.tooltip.width || "auto"};
        max-width: min(260px, calc(100vw - 20px));
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;
        text-align: center;
        line-height: 1.3;
        z-index: 99999;
        transition: opacity 0.25s ease, transform 0.25s ease;
      }

      .chat-button:hover .chat-tooltip {
        visibility: visible;
        opacity: 1;
      }
    `;
    document.head.appendChild(style);

    return () => style.remove();
  }, [btn]);

  // ======= Posición del tooltip =======
  useEffect(() => {
    const tooltip = document.querySelector(".chat-tooltip") as HTMLElement;
    if (!tooltip) return;

    // limpiamos todas las posiciones anteriores
    tooltip.style.top = "";
    tooltip.style.bottom = "";
    tooltip.style.left = "";
    tooltip.style.right = "";
    tooltip.style.transform = "";

    const position = btn.tooltip.position || "arriba";

    switch (position) {
      case "abajo":
        tooltip.style.top = "calc(100% + 8px)";
        tooltip.style.left = "50%";
        tooltip.style.transform = "translateX(-50%)";
        break;
      case "izquierdo":
        tooltip.style.right = "calc(100% + 8px)";
        tooltip.style.top = "50%";
        tooltip.style.transform = "translateY(-50%)";
        break;
      case "derecho":
        tooltip.style.left = "calc(100% + 8px)";
        tooltip.style.top = "50%";
        tooltip.style.transform = "translateY(-50%)";
        break;
      default: // arriba
        tooltip.style.bottom = "calc(100% + 8px)";
        tooltip.style.left = "50%";
        tooltip.style.transform = "translateX(-50%)";
        break;
    }
  }, [btn.tooltip.position, btn.tooltip.text]);


  // ======= Render =======
 
  return (
    <>
      {!isChatOpen && (
        <button
          style={{
            position: "fixed",
            bottom: btn.position.bottom,
            right: btn.position.right,
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 0,
            outline: "none",
            zIndex: 9999,
          }}
          onClick={() => setIsChatOpen(true)}
        >
          <span className="chat-button">
            <span
              className="chat-icon"
              dangerouslySetInnerHTML={{ __html: btn.iconSvg }}
            />
            {btn.text && <span className="chat-text">{btn.text}</span>}
            <span className="chat-tooltip">{btn.tooltip.text}</span>
          </span>
        </button>
      )}

      {isChatOpen && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            width: ifr.width,
            height: ifr.height,
            background: ifr.backgroundColor,
            border: `1px solid ${ifr.borderColor}`,
            borderRadius: ifr.borderRadius,
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            overflow: "hidden",
            zIndex: 9998,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <button
            onClick={() => setIsChatOpen(false)}
            style={{
              position: "absolute",
              top: "-15px",
              right: "20px",
              transform: "translateX(-50%)",
              width: "50px",
              height: "38px",
              border: "none",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              zIndex: 10000,
              backgroundColor: "#ecf2ff",
              color: "#0048cf",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              paddingBottom: "5px",
              transition: "background-color 0.3s ease",
            }}
            onMouseEnter={(e) =>
              ((e.target as HTMLElement).style.backgroundColor = "#0048cf7e")
            }
            onMouseLeave={(e) =>
              ((e.target as HTMLElement).style.backgroundColor = "#ecf2ff")
            }
          >
            ✕
          </button>

          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#555",
              fontSize: 14,
              background: "#fff",
            }}
          >
            <div>
              <strong>Vista previa del chat</strong>
              <p style={{ fontSize: 12, color: "#888" }}>
                Aquí aparecería el chat real.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
*/